import { DocFile } from '@app/shared';
import { SolutionManager } from "./solution-manager";

export class OrgDocument extends SolutionManager {

  type: string;
  description: string;
  mandatory: boolean;

  employeeClassId: number;
  employeeClassName?: string;
  managingObsId: number;
  managingObsName: string;

  docFile?: DocFile;
  docFileId?: any;
  docFileName?: string;

  txnTypeId?: any;

  constructor (managingOrgId?: number) {
    super(managingOrgId);
    this.mandatory = false;
  }
}